export const APPLY_USER = "APPLY_USER";

export const GET_INTEREST = "Fetch all user's interests";
export const GET_FAV_INTEREST = "Fetch fav user's interests";
export const SET_INTERESTS = "SET_INTERESTS";
export const GET_INTERESTS = "GET_INTERESTS";
export const UPDATE_MEMBERSHIP = "UPDATE_MEMBERSHIP";
export const APPLY_USER_DETAILS = 'APPLY_USER_DETAILS';
// todo: borrar GET_FAV_INTEREST
